/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from 'zod';

export const customClosingDayFormSchema = z.object({
  date: z.date(),
  name: z.string().min(1),
  branchIds: z.array(z.string()).nullable(),
  recurring: z.boolean(),
});

export type CustomClosingDayFormValues = z.infer<typeof customClosingDayFormSchema>;

export const updatePublicClosingDaySchema = z.object({
  branchIds: z.array(z.string()).nullable(),
  enabled: z.boolean(),
});

export type UpdatePublicClosingDayFormValues = z.infer<typeof updatePublicClosingDaySchema>;
